import sessionService from "@services/session.service";
import { notification } from "antd";
import Axios, { AxiosObservable } from "axios-observable";
import { Headers, ignorableUrls } from "./constants";
// import session from "@services/session.service";
import storage from "@services/storage.service";
import axios from "axios";

// Axios.defaults.withCredentials = true

export type IndexSignature = {
  [key: string]: any;
};

export function get<T>(url: string, params?: IndexSignature): AxiosObservable<T> {
  return Axios.get(url, params);
}

export function post<T>(url: string, body?: any, params?: IndexSignature): AxiosObservable<T> {
  return Axios.post(url, body, params);
}

export function put<T>(url: string, body?: any, params?: IndexSignature): AxiosObservable<T> {
  return Axios.put(url, body, params);
}

export function del<T>(url: string, body?: any, params?: IndexSignature): AxiosObservable<T> {
  return Axios.delete(url, params);
}

// Intercepting request to add default headers
Axios.interceptors.request.use(
  async function (config: any) {
    const itemFound = ignorableUrls.filter((iu) => config?.url?.includes(iu));
    if (!itemFound || itemFound.length === 0) {
      // const token = await sessionService.getToken();
      const token = storage.get("_token");
      config.headers[Headers.Authorization] = `Bearer ${token}`;
      // config.headers[Headers.refreshAuthorization] = storage.get("_refreshToken");
    }
    if (!(config?.url?.includes(process.env.REACT_APP_MAP_BASE_URL) || config?.url?.includes(process.env.REACT_APP_WEATHER_BASE_URL))) {
      config.headers[Headers.ContentType] = "application/json";
      config.headers[Headers.HTTPReferrer] = window.location.hostname;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Intercepting response to add notification
Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const data = error?.response?.data;
    const originalRequest = error.config;

    if (error?.config?.url?.includes('refreshToken')) {
      sessionService.logout();
      window.location.href = `/`;
      return Promise.reject(error);
    }

    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (error.response.status === 401 && !originalRequest._retry && !error?.config?.url?.includes('login')) {
      originalRequest._retry = true;

      try {
        // if (!sessionService.isValidToken()) {
          await sessionService.refreshToken();
          const token = storage.get("_token");

          localStorage.setItem("token", token);

          // Retry the original request with the new token
          originalRequest.headers.Authorization = `Bearer ${token}`;
        // }
        return axios(originalRequest);
      } catch (error) {
        return Promise.reject(error);
      }
    } else {
      notification.error({
        message: data?.status ? data?.status : "Error",
        description: data?.data?.message,
        onClick: () => {},
      });
    }
    return Promise.reject(error);
  }
);
